/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var DesktopsIllustrationEditHomeIcon = createIcon("DesktopsIllustrationEditHomeIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0v80h80V0Z",
    fill: "#E1F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5.5H.5v79h79V.5Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 33H8a1 1 0 00-1 1v13a1 1 0 001 1h29a1 1 0 001-1V34a1 1 0 00-1-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 33.5h-28a1 1 0 00-1 1v12a1 1 0 001 1h28a1 1 0 001-1v-12a1 1 0 00-1-1Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 33H43a1 1 0 00-1 1v13a1 1 0 001 1h29a1 1 0 001-1V34a1 1 0 00-1-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 33.5h-28a1 1 0 00-1 1v12a1 1 0 001 1h28a1 1 0 001-1v-12a1 1 0 00-1-1Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 37.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 37.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 37.5a1 1 0 100-2 1 1 0 000 2Zm31 0a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 37.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 37.5a1 1 0 100-2 1 1 0 000 2Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 38h-7v7h7v-7Zm35 0h-7v7h7v-7Z",
    fill: "#C8C8C8"
  }));
}, {});